import { render, staticRenderFns } from "./MobileLiveMain.vue?vue&type=template&id=1374c27d&scoped=true"
import script from "./MobileLiveMain.vue?vue&type=script&lang=js"
export * from "./MobileLiveMain.vue?vue&type=script&lang=js"
import style0 from "./MobileLiveMain.vue?vue&type=style&index=0&id=1374c27d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1374c27d",
  null
  
)

export default component.exports